<template>
  <div class="wall overflow-auto" id="wall">
    <div v-for="(u,i) in dialog.utterances" :key="i" class="mb-3">
      <b-row v-if="u.person && u.person.personName==user">
        <b-col cols="7">
        <b-card
           >
          <b-badge variant="light">{{user}}</b-badge>
          {{u.text}}
        </b-card>
        </b-col>
        <b-col cols="5"></b-col>
      </b-row>
      <b-row v-else>
        <b-col cols="5"></b-col>
        <b-col cols="7">
          <b-card
             >
            <b-badge variant="light">{{u.person.personName}}</b-badge>
            {{u.text}}
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DialogWall',
  computed: {
    user () {
      return (this.$store.state.user)
        ? this.$store.state.user : null;
    },
    dialog () {
      return this.$store.state.dialog;
    }
  }
}
</script>

<style scoped>
  .wall {
    height: 70vh;
  }
  .card-body {
    padding: 8px;
  }
</style>
